export function shuffleArray<T>(array: T[]): T[] {
  const dataToShuffle = [...array];

  for (let i = dataToShuffle.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [dataToShuffle[i], dataToShuffle[j]] = [dataToShuffle[j], dataToShuffle[i]];
  }

  return dataToShuffle;
}
